import {Component, inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription, Observable, throwError } from 'rxjs';
import {Store} from "@ngrx/store";
import { ShareDataService, AuthService, SeoService_Generic } from '@signature-it/ngx-generic/services';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import { RestUrlsConfig, GenericConfig} from '@signature-it/ngx-generic/config';
import * as fromSelectors from '@signature-it/ngx-catalogue/store/selectors';
import {PriceDTO} from '@signature-it/ngx-catalogue/models';
import {TooltipDirective} from 'ngx-bootstrap/tooltip';
import {EntityService } from '@signature-it/ngx-entity/services';
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import * as EntitySelectors from '@signature-it/ngx-entity/store/selectors';
import {getCurrencySymbol} from '@angular/common';

declare let _: any;


@Component({
    selector: 'price',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.scss'],
    standalone: false
})

export class PriceComponent_Catalogue implements OnInit, OnDestroy{

    @Input() pid: number;
    @Input() moreInfo: string;
    @Input() previewTemplateVar: string;
    @Input() showAutoShipment: boolean;
    @Input() numberFormat = false;
    @Input() fractionDigits = '00';
    @ViewChild('clubPriceToolTip') clubPriceToolTip: TooltipDirective;
    protected subscriptionsList$: Array<Subscription> = [];
    priceList$: Observable<PriceDTO[]>;
    loadingPriceList$: Observable<boolean>;
    price: PriceDTO;
    priceCurrency = '';
    exclusiveImageUrl: string;
    clubRegistrationLink = GenericConfig.clubRegistrationLink || '';
    showTotalSaved = GenericConfig.showTotalSaved || false;
    priceDisplay = GenericConfig.priceDisplay || null;
    priceCurrentLabel = GenericConfig.priceCurrentLabel || false;
    proLoggedIn: boolean = false;
    b2bLoggedIn: boolean = false;
    currencySymbol = GenericConfig.currencySymbol == 'symbol-narrow' ? 'symbol-narrow' : 'symbol';
    templates$: Observable<any>;
    loadingTpl$: Observable<boolean>;
    protected seoSvc: SeoService_Generic

    constructor(protected store$: Store<any>,
                protected restUrlsConf: RestUrlsConfig,
                protected authService: AuthService,
                public shareDataService: ShareDataService,
                protected entityService: EntityService,) {
        this.priceList$ = this.store$.select(fromSelectors.getCataloguePriceList);
        this.loadingPriceList$ = this.store$.select(fromSelectors.getLoadingPriceList);
        this.exclusiveImageUrl = `${this.restUrlsConf.beURL}/images/Fittings/${GenericConfig.systemName}/field_images/exclusive/exclusive_`;
        this.seoSvc = inject(SeoService_Generic);
    }

    ngOnInit() {
        this.registerSubscription();
        this.shareDataService.loginData$.subscribe(
            (isLoggedIn: boolean) => {
                this.authService.currentUsersData$.subscribe((user: IUser) => {
                    this.proLoggedIn = user && user.user_club ? true : false;
                    this.b2bLoggedIn = user && user.isB2B() ? true : false;
                });
            }
        );
        if(this.previewTemplateVar ) {
            this.templates$ = this.store$.select(EntitySelectors.getPreviews);
            this.loadingTpl$ = this.store$.select(EntitySelectors.getIsLoadingPreviews);
        }
    }

    registerSubscription() {
		let sb1$ = this.priceList$.subscribe((priceList: PriceDTO[]) => {
			if(priceList && priceList.length) {
				this.price = _.filter(Array.from(priceList), {'id': this.pid.toString() })[0];
                this.seoSvc.updatePageData('price', this.price);
				this.priceCurrency = getCurrencySymbol(this.price?.currency, "wide");
			}
		});
		this.subscriptionsList$.push(sb1$);
    }

    ngOnDestroy() {
        _.each(this.subscriptionsList$, (s) => s.unsubscribe());
    }

    hideToolTip() {
        this.clubPriceToolTip.hide();
    }
}
